import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client.js';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      // Server returns generic success even on failures, so this catch is rare —
      // still show the same confirmation to keep UX consistent.
      setSent(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="bg-navy h-2" />
      <div className="bg-crimson h-1" />
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-sm">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold mt-2">Reset Password</h1>
            <div className="rule-crimson mx-auto" />
          </div>

          {!sent && (
            <form onSubmit={onSubmit} className="card p-6 space-y-4">
              <p className="text-sm text-muted">
                Enter your email. If we have an account on file, you'll get a
                password reset link.
              </p>
              <div>
                <label className="label">Email</label>
                <input type="email" className="input" value={email}
                       onChange={e => setEmail(e.target.value)}
                       autoComplete="username" required autoFocus />
              </div>
              <button type="submit" disabled={busy || !email} className="btn-primary w-full">
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
              <div className="text-center">
                <Link to="/login" className="text-sm text-navy hover:underline">Back to sign in</Link>
              </div>
            </form>
          )}

          {sent && (
            <div className="card p-6 space-y-3 text-sm">
              <div className="font-medium text-navy">Check your email.</div>
              <p className="text-muted">
                If <b>{email}</b> matches an active account, you'll receive a
                reset link within a minute. The link expires in 1 hour.
              </p>
              <p className="text-muted">
                Don't see it? Check your spam folder. If it still doesn't show
                up, ask your admin to reset the password directly.
              </p>
              <div className="pt-2">
                <Link to="/login" className="text-navy hover:underline">Back to sign in</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
